import { inject } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router'
import { UserPreferenceService } from '@se-po/shared-data-access-services'
import { Observable, map } from 'rxjs'

export const credentialsRouteGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const router = inject(Router)
    const personFilters = next.parent.params.id
    const orgId = next.parent.params.orgId
    const urlTree = router.createUrlTree(['user', 'credentials'], { queryParams: { orgId, personFilters } })
    return mySeVersionRedirect(urlTree)
}

export const membershipsRouteGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const router = inject(Router)
    const personFilters = next.parent.params.id
    const urlTree = router.createUrlTree(['user', 'memberships'], { queryParams: { personFilters } })
    return mySeVersionRedirect(urlTree)
}

export const orgRouteGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const router = inject(Router)
    const personaId = next.parent.params.id
    const urlTree = router.createUrlTree(['user', 'organizations-page', personaId])
    return mySeVersionRedirect(urlTree)
}

export const profileRouteGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
    const router = inject(Router)
    const personaId = next.params.id
    const navExtras = personaId ? { queryParams: { id: personaId } } : { }
    const urlTree = router.createUrlTree(['user', 'household'], navExtras)
    return mySeVersionRedirect(urlTree)
}

const mySeVersionRedirect = (urlTree: UrlTree): Observable<boolean | UrlTree>  => {
  const userPreferenceService = inject(UserPreferenceService)
  return userPreferenceService.mySeVersion().pipe(
    map(result => {
      if (Number(result) >= 2) {
        return urlTree
      } else {
        return true
      }
    })
  )
}


